export enum DrawingModes {
  marker = 'marker',
  area = 'area',
  circle = 'circle',
  reset = 'reset',
  remove = 'remove',
}
